"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerFullNameByDriversLicenseData = exports.formatDriversLicenseDob = exports.getAgeByDriversLicenseDob = exports.getCustomerSearchFilterOptionLabel = void 0;
const models_1 = require("./models");
const getCustomerSearchFilterOptionLabel = (option) => {
    switch (option) {
        case models_1.CustomerSearchFilterOptions.CARD_ID:
            return 'Card ID';
        case models_1.CustomerSearchFilterOptions.EMAIL:
            return 'Email';
        case models_1.CustomerSearchFilterOptions.NAME:
            return 'Name';
        case models_1.CustomerSearchFilterOptions.PHONE_NUMBER:
        default:
            return 'Phone number';
    }
};
exports.getCustomerSearchFilterOptionLabel = getCustomerSearchFilterOptionLabel;
const getAgeByDriversLicenseDob = (dobString) => {
    // Input format is YYYYMMDD
    const year = parseInt(dobString.slice(0, 4), 10);
    const month = parseInt(dobString.slice(4, 6), 10) - 1;
    const day = parseInt(dobString.slice(6, 8), 10);
    const dob = new Date(year, month, day);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
    }
    return age;
};
exports.getAgeByDriversLicenseDob = getAgeByDriversLicenseDob;
const formatDriversLicenseDob = (dobString) => {
    // Input format is YYYYMMDD
    const year = dobString.slice(0, 4);
    const month = dobString.slice(4, 6);
    const day = dobString.slice(6, 8);
    return `${year}-${month}-${day}`;
};
exports.formatDriversLicenseDob = formatDriversLicenseDob;
const getCustomerFullNameByDriversLicenseData = (firstName, middleName, familyName) => {
    if (middleName && middleName.trim().length > 0) {
        return `${firstName} ${middleName} ${familyName}`;
    }
    return `${firstName} ${familyName}`;
};
exports.getCustomerFullNameByDriversLicenseData = getCustomerFullNameByDriversLicenseData;
//# sourceMappingURL=helpers.js.map